import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateRangeValidator(
  startControlName: string,
  endControlName: string,
  errorKey: string,
) {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDate = control.get(startControlName)?.value;
    const endDate = control.get(endControlName)?.value;
    const endControl = control.get(endControlName);

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (end < start) {
        const currentErrors = endControl?.errors || {};
        endControl?.setErrors({ ...currentErrors, [errorKey]: true });
        return { [errorKey]: { start: startControlName, end: endControlName } };
      }
    }
    // Clear the error if valid
    if (endControl?.hasError(errorKey)) {
      const currentErrors = endControl.errors;
      if (currentErrors) {
        delete currentErrors[errorKey];
        endControl.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
      }
    }
    return null;
  };
}
